<template>
  <v-btn color="primary"
         small
         outline
         @click="goTo('shipmentPickup', shipment.id)"
         v-if="canRequestPickup"
         >
         {{ $t('pickup') }}
  </v-btn>
</template>

<script>
export default {
  name: 'ShipmentPickupBtnComp',

  props: {
    shipment: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
    }
  },

  components: {
  },

  computed: {
    rate () {
      if (!this.shipment) { return {} }
      if (!this.shipment.rate) { return {} }

      return this.shipment.rate
    },

    canRequestPickup () {
      if (!this.shipment.status === 'success') { return false }
      if (!this.rate) { return false }
      if (!this.rate.service) { return false }
      if (!this.rate.service.carrier) { return false }

      const providers = ['Fedexx', 'FedexRest', 'DHL', 'PExpress', 'Redpack', 'AMPM', 'Pak2go', 'DrEnvio']
      const code = this.rate.service.carrier.provider.code
      if (providers.includes(code)) { return true }

      return false
    }
  },

  methods: {
  },

  watch: {
  },

  async mounted () {
  }
}
</script>
